import { CountryType } from "types/Catalogs";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ICountriesStore {
  countries: CountryType[] | null;
  countryCode: string;
  isCountriesOpen: boolean;
  setCountries: (countries: CountryType[]) => void;
  setCountryCode: (country: string) => void;
  setIsCountriesOpen: (isCountriesOpen: boolean) => void;
}

export const useCountriesStore = createWithEqualityFn<ICountriesStore>()(
  devtools(
    persist(
      (set) => ({
        countries: null,
        countryCode: "",
        isCountriesOpen: false,
        setCountryCode: (country: string) => {
          set({ countryCode: country });
        },
        setCountries: (countries: CountryType[]) => {
          set({ countries });
        },
        setIsCountriesOpen: (isCountriesOpen: boolean) => {
          set({ isCountriesOpen });
        },
      }),
      {
        name: "country-storage",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ countryCode: state.countryCode }),
      },
    ),
    { name: "Country Store" },
  ),
  shallow,
);
